import { useGroupData } from '../hooks/useGroupData';
import { formatPhone } from '../utils/helpers';
import LoadingSpinner from '../components/LoadingSpinner';

export default function GroupPage() {
  const { group, members, kids, loading, error } = useGroupData();

  if (loading) return <div className="flex justify-center p-8"><LoadingSpinner /></div>;
  if (error) return <div className="p-4 text-red-500 text-center">{error}</div>;
  if (!group) return <div className="p-4 text-center text-gray-500">No group found</div>;

  return (
    <div className="max-w-lg mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4 dark:text-white">{group.name}</h1>

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-5 mb-4">
        <h2 className="font-semibold mb-3 dark:text-white">Members ({members.length})</h2>
        <div className="space-y-3">
          {members.map(m => (
            <div key={m.id} className="flex items-center justify-between py-2 border-b last:border-0 dark:border-gray-700">
              <div>
                <p className="font-medium dark:text-gray-200">{m.name}</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">{formatPhone(m.phoneNumber)}</p>
              </div>
              <span className="text-xs px-2 py-1 rounded-full bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300">{m.role}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-5">
        <h2 className="font-semibold mb-3 dark:text-white">Kids ({kids.length})</h2>
        <div className="space-y-2">
          {kids.map(k => {
            const parent = members.find(m => m.id === k.parentId);
            return (
              <div key={k.id} className="flex items-center justify-between py-2 border-b last:border-0 dark:border-gray-700">
                <span className="dark:text-gray-200">{k.name}</span>
                <span className="text-sm text-gray-500 dark:text-gray-400">{parent?.name || 'Unknown'}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
